import { AbstractControl, ValidationErrors } from "@angular/forms";
import { Observable, of, timer } from "rxjs";
import { catchError, first, map, switchMap } from "rxjs/operators";
import { OrganizationGateway } from "../gateways";

export const uniqueAffiliationNameValidator = (
    organizationService: OrganizationGateway,
    originalValue: string
) => {
    return (
        control: AbstractControl
    ): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
        if (!control.value || originalValue === control.value) return of(null);
        const trimmedValue = control.value.trim();

        return timer(300).pipe(
            switchMap(() => organizationService.getAffiliations()),
            map(affiliations => {
                const exists = affiliations.some(x => x.displayName.trim() === trimmedValue);
                return exists ? { affiliationNameTaken: true } : null;
            }),
            catchError(() => of(null)),
            first()
        );
    };
};
